app.service("shopsList", function() {
	var $self;
	function update(html){
		$self.html(html);
	}
	function init(){
		$self=$('#shops-list');
		$self.on('click', '.js-shop', function(e){
			if($(e.target).is('.js-reserve, .js-go-to-navigation, .js-shop-list-phone') === false) {
				$(this).toggleClass('more');
			}
		});
	}
	return {
		init: init,
		update:update
	};
});